<template>
  <v-container>
    <v-tabs v-model="tab" background-color="primary" dark>
      <v-tab v-for="(tabItem, index) in tabs" :key="index">
        {{ tabItem }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <bundle-list />
      </v-tab-item>
      <v-tab-item>
        <bundle-content />          
      </v-tab-item>
      <v-tab-item>
        <bundle-change-number />
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>
<script>


import BundleList from '@/components/admin/bundle/BundleList'
import BundleContent from '@/components/admin/bundle/BundleContent'
import BundleChangeNumber from '@/components/admin/bundle/BundleChangeNumber'

export default{
    name:'Bundles',
    components:{BundleList,BundleContent,BundleChangeNumber},
    data() {
        return {
            tab: null,
            tabs: ['Buntblock', 'Buntinnehåll','Ändra Buntnummer'],            
            customerId: undefined,            
        }
    },
    computed:{      
    },
    watch: { 
      customerId: function() { // watch it          
         this.bundles = []
         this.bundleContent = []
         this.loading = false     
         this.filterBundleId= ''
         this.filterOnId=false
      },      
    },
    mounted() {        
    
    },
    methods: {    
    }
}
</script>

<style scoped>
span {
    font-size: 1em;
}

.input >>> input[type="number"] {
  appearance: textfield;  
  -moz-appearance: textfield;  
}
.input >>> input::-webkit-outer-spin-button,
.input >>> input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

</style>